import React, { Component } from "react";
import PropTypes from "prop-types";
import { ERROR_MSG } from "../constant";
import { Form } from "react-bootstrap";
import { debounce } from "lodash";
import { clearDebounce } from "../helper";
import { InnerLoader } from "./Loader";

const REGEX = {
  string: /([^a-z ]+)/i,
  number: /([^0-9]+)/i
};

export class Field extends Component {
  delayUpdate = null;

  onStrictTypeTyping = (value, strictType) => {
    const { pattern } = this.props;
    try {
      let defaultPattern;
      switch (strictType) {
        case "string":
          defaultPattern = pattern || REGEX.string;
          return defaultPattern.test(value);

        case "number":
          defaultPattern = pattern || REGEX.number;
          return defaultPattern.test(value);

        default:
          defaultPattern = pattern || false;
          return defaultPattern && defaultPattern.test(value);
      }
    } catch (e) {
      console.log("Error message on validate - ", e.message);
    }
  };

  onKeyPress = e => {
    const { key } = e;
    const { pattern, strictType } = this.props;
    //////////////////////////////////////////
    // if (key === "Enter") {
    //   e.preventDefault();
    // }
    /////////////////////////
    if (pattern) {
      const isValid = this.onStrictTypeTyping(key, strictType);
      isValid && e.preventDefault();
      return false;
    }
    return true;
  };

  /**
   *
   * @param e
   */
  onChange = e => {
    //
    try {
      const { onChange, onError, keyName } = this.props;
      const { value } = e.target;
      let nameText = "";
      if (e.target.tagName === "SELECT") {
        nameText = e.target.options[e.target.selectedIndex].text
          .split(" ")
          .splice(0, 1)
          .join(" ");
      }

      onChange(value, keyName, this.element, nameText);
      typeof onError === "function" && this.onError(value.trim());
    } catch (e) {
      console.log("Error message: - ", e.message);
    }
  };

  onClick = e => {
    try {
      const { onClick, onError, keyName } = this.props;
      const { value } = e.target;
      onClick(value, keyName, this.element);
      typeof onError === "function" && this.onError(value.trim());
    } catch (e) {
      console.log("Error message: - ", e.message);
    }
  };

  onError = value => {
    const { onError, delay, keyName } = this.props;
    clearDebounce(this.delayUpdate);
    this.delayUpdate = debounce(() => {
      onError(
        {
          error: !value,
          message: !value && ERROR_MSG.DEFAULT_MSG
        },
        keyName
      );
    }, delay);
    this.delayUpdate();
  };

  onBlur = e => {
    const { value } = e.target;
    const { onBlur } = this.props;
    onBlur(value);
  };
  render() {
    const { loading, disabled } = this.props;
    return (
      <React.Fragment>
        <InnerLoader loading={loading} />
        <Form.Control
          {...this.props}
          disabled={disabled}
          autoComplete={"off"}
          onChange={this.onChange}
          onClick={this.onClick}
          onKeyPress={this.onKeyPress}
          ref={elem => {
            this.element = elem;
          }}
          name={null}
          onBlur={this.onBlur}
        >
          {this.props.children}
        </Form.Control>
      </React.Fragment>
    );
  }
}

Field.propTypes = {
  type: PropTypes.string,
  pattern: PropTypes.string,
  onChange: PropTypes.func,
  onError: PropTypes.func,
  delay: PropTypes.number
};

Field.defaultProps = {
  type: "",
  pattern: "",
  onChange: () => {},
  onError: () => {},
  onClick: () => {},
  delay: 0
};
